<template>
    <div class="alarm-dropdown-container" ref="dropdownRoot">
        <!-- 토글 버튼 -->
        <div class="alarm-toggle" @click="toggleDropdown">
            <i class="fa fa-bell bell-icon" :style="{ color: mapSeverityColor(highestSeverity) }"></i>
            <span class="label" v-if="alarmCount > 0" :style="getBadgeStyle()">
                {{ Number(alarmCount) > 999 ? "999+" : alarmCount }}
            </span>
        </div>

        <!-- 커스텀 드롭다운 메뉴 -->
        <transition name="fade-popup">
            <div class="alarm-dropdown-menu" v-if="dropdownOpen">
                <div class="dropdown-header">
                    {{ $t("알람로그") }}
                    <button @click.stop="toggleDropdown" class="alarm-event-hide">
                        <i class="fas fa-times alarm-stop-icon"></i>
                    </button>
                </div>

                <!-- AlarmList 컴포넌트 삽입 -->
                <div class="alarm-scroll-container">
                    <alarm-list
                        v-if="dropdownOpen"
                        :alarms="alarmList"
                        :alarlDropdownShow="dropdownOpen"
                        @holdCallback="test"
                        @update-alarm-list="getAlarmListWrapper"
                        @close-alarm-dropdown="toggleDropdown"
                    />
                </div>
                <div class="drop-down-else text-center" v-if="!isMobile" @click="openAlarmList">
                    {{ $t("더보기") }}
                </div>
            </div>
        </transition>
        <!-- :id="`alarm-toast-${idx}`" -->

        <div v-if="hasAlarms" class="toasts-wrapper">
            <b-toast
                v-for="(alarm, idx) in alarmLogList"
                :key="idx"
                :bv-toast-id="`alarm-toast-${alarm.alarmLogIdx}`"
                :variant="mapSeverityToVariant(alarm.severity)"
                toaster="b-toaster-bottom-right"
                solid
                :no-auto-hide="false"
                :auto-hide-delay="8000"
                :visible="true"
            >
                <template #toast-title>
                    <div class="d-flex align-items-center">
                        <span class="mr-2">{{ severityIcon(alarm.severity) }}</span>
                        <strong class="mr-2">[{{ severityText(alarm.severity) }}]</strong>
                        <strong class="text-muted">{{ alarm.modDate ?? "-" }}</strong>
                    </div>
                </template>
                <div>{{ `[${alarmTypeText(alarm.alarmType)}]` }}</div>
                <div>{{ alarm.message }}</div>
            </b-toast>
        </div>
    </div>
</template>

<script>
import backEndApi from "@src/api/backEndApi";
import AlarmList from "./AlarmList.vue";
import { mapGetters, mapActions } from "vuex";
const { forObj } = global.xe;

export default {
    components: { AlarmList },
    data() {
        return {
            dropdownOpen: false,
            alarms: [],
            formerAlarms: [],
            alarmCount: 0,
            alarmList: { rows: [] },
            highColor: "red",
            midColor: "orange",
            lowColor: "green",
            highestSeverity: "Low",
            alarlDropdownShow: false,

            // 토스트 테스트
            // testCounter: 1,
        };
    },
    computed: {
        ...mapGetters({
            alarmRegDt: "alarmLogsRegDt",
            alarmLogList: "alarmLogLists",
            alarmBadgeFlag: "getAlarmFlag",
            isMobile: "isMobile", // 가정: 모바일 플래그
        }),
        hasAlarms() {
            return Array.isArray(this.alarmLogList) && this.alarmLogList.length > 0;
        },
    },
    watch: {
        alarmBadgeFlag() {
            this.refreshAlarmCount();
            this.updateAlarmBadge(false);
        },
        alarmRegDt() {
            const alarmLogs = JSON.parse(localStorage.alarmLogs || "[]");
            this.onChangeAlarms(alarmLogs);
        },

        alarmLogList() {
            this.triggerAlarms();
        },
    },
    mounted() {
        document.addEventListener("click", this.onClickOutside);
        // this.initSetting();
        this.refreshAlarmCount();
        this.getAlarmListWrapper();
        this.intervalId = setInterval(this.intervalCallAlarm, 300000);

        // 테스트
        // ✅ 10초마다 테스트 알람 추가
        // setInterval(() => {
        //     const dummyAlarm = {
        //         alarmLogIdx: `test-${this.testCounter}`,
        //         severity: ["Low", "Medium", "High", "Critical"][Math.floor(Math.random() * 4)],
        //         alarmType: "abnormalData",
        //         message: `테스트 알람 메시지 ${this.testCounter}`,
        //         modDate: new Date()
        //             .toISOString()
        //             .slice(0, 19)
        //             .replace("T", " "),
        //     };
        //     this.$store.state.selectedAlarmLogIdx = null; // 필요에 따라 초기화
        //     this.$store.state.alarmLogList.push(dummyAlarm);
        //     this.testCounter++;

        //     this.$nextTick(() => {
        //         this.$bvToast.show(`alarm-toast-${this.$store.state.alarmLogList.length - 1}`);
        //     });
        // }, 10000);
    },
    beforeDestroy() {
        document.removeEventListener("click", this.onClickOutside);
        clearInterval(this.intervalId);
    },
    methods: {
        ...mapActions({ updateAlarmBadge: "UPDATE_ALARM_BADGE" }),
        getBadgeStyle() {
            const count = this.alarmCount;
            // const count = 1;
            const digits = count > 999 ? 4 : String(count).length;
            const positionMap = {
                1: "12px", // 1자리
                2: "6px", // 2자리
                3: "1px", // 3자리
                4: "-6px", // "999+" 포함
            };

            return {
                backgroundColor: this.mapSeverityColor(this.highestSeverity),
                color: "#fff",
                opacity: 0.8,
                right: positionMap[digits] || "-12px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",

                // 한자리수일땐 좀 더 뱃지를 둥글게 보이기위함
                width: digits === 1 ? "15px" : "",
                height: digits === 1 ? "15px" : "",
                borderRadius: digits === 1 ? "50%" : "",
            };
        },
        initSetting() {
            // TODO: 여기서 그룹핑하지 말고, 서버에서 그룹핑하여 전송해야 할듯...
            // backEndApi.notification.searchAlarmNotification(500).then(({ data }) => {
            // 	if (this.$err(data)) return;

            // 	this.onChangeAlarms(data);
            // });

            this.onChangeAlarms(JSON.parse(localStorage.alarmLogs));
        },
        // 토글
        async toggleDropdown() {
            if (!this.dropdownOpen) {
                // 열기 직전에 API 먼저 기다림
                await this.getAlarmListWrapper();
                this.dropdownOpen = true;
            } else {
                this.dropdownOpen = false;
                this.alarlDropdownShow = false;
            }
        },
        onClickOutside(e) {
            const clickedInDropdown = this.$refs.dropdownRoot.contains(e.target);
            const isDownloadAnchor = e.target.tagName === "A" && e.target.hasAttribute("download");
            const clickedInModal = !!e.target.closest(".modal");
            if (!clickedInDropdown && !clickedInModal && !isDownloadAnchor) {
                this.dropdownOpen = false;
                this.alarlDropdownShow = false;
            }
        },

        // 색상/레이블
        mapSeverityColor(sev) {
            return (
                { Critical: this.highColor, High: this.highColor, Medium: this.midColor, Low: this.lowColor }[sev] ||
                "#888"
            );
        },
        mapSeverityToVariant(sev) {
            return { Critical: "danger", High: "warning", Medium: "info", Low: "success" }[sev] || "secondary";
        },
        severityText(sev) {
            const find = this.$store.state.commonCodes.alarmSeverity.find((i) => i.value === sev);
            return find ? find.text : sev;
        },
        alarmTypeText(type) {
            const find = this.$store.state.commonCodes.alarmType.find((i) => i.value === type);
            return find ? find.text : type;
        },
        severityIcon(sev) {
            return { Critical: "☠️", High: "⚠️", Medium: "📣", Low: "ℹ️" }[sev] || "🔔";
        },

        // 알람 리스트
        async getAlarmListWrapper() {
            this.alarlDropdownShow = true;
            try {
                const { data } = await backEndApi.newAlarm.getActiveAlarmList();
                this.alarmList = data;
                this.highestSeverity = this.getHighestSeverity(data.rows);
            } catch (e) {
                console.warn(e);
            }
        },
        getHighestSeverity(rows) {
            const priority = { Critical: 4, High: 3, Medium: 2, Low: 1 };
            return rows.reduce(
                (max, a) => (priority[a.severity] > priority[max] ? a.severity : max),
                rows.length ? rows[0].severity : "Low"
            );
        },
        async refreshAlarmCount() {
            try {
                const { data } = await backEndApi.newAlarm.getActiveAlarmEventCount();
                this.alarmCount = data.rowCount;
            } catch (e) {
                console.error(e);
            }
        },
        intervalCallAlarm() {
            this.refreshAlarmCount();
            this.getAlarmListWrapper();
        },

        // 토스트 알림
        async triggerAlarms() {
            this.alarmLogList.forEach((_, idx) => this.$bvToast.show(`alarm-toast-${idx}`));
            await this.refreshAlarmCount();
            await this.getAlarmListWrapper();
        },

        // 알람 저장
        onChangeAlarms(alarmLogs) {
            if (this.isEmpty(localStorage.getItem("accessToken"))) return;

            try {
                for (let i = 0; i < alarmLogs.length; i++) {
                    let alarm = alarmLogs[i];

                    if (this.formerAlarms.findIndex((v) => v.alarmLogIdx === alarm.alarmLogIdx) !== -1) {
                        alarmLogs.splice(i, 1);
                        i--;
                    }
                }

                let objectAlarm = {};

                for (let i = 0; i < alarmLogs.length; i++) {
                    let alarm = alarmLogs[i];

                    if (Object.keys(objectAlarm).includes(`${alarm.alarmGroup}/${alarm.ptAddr}`) === false) {
                        objectAlarm[`${alarm.alarmGroup}/${alarm.ptAddr}`] = [];
                    }
                    objectAlarm[`${alarm.alarmGroup}/${alarm.ptAddr}`].push(alarm);

                    if (this.formerAlarms.length > 100) {
                        this.formerAlarms.shift();
                    }

                    this.formerAlarms.push(alarm);
                    this.alarms.unshift(alarm);
                }

                let notifiedAlarms = this.readStorage("notifiedAlarms");

                forObj(objectAlarm, (group, key) => {
                    let isIncludes = group.find((v) => v.regDt === notifiedAlarms[key]);

                    if (this.isEmpty(isIncludes)) {
                        let log = group[0];

                        this.alertNoti(
                            "알람",
                            `${log.alarmGroup} <br /> ${log.description} <br /><br /> ${log.regDt.passedTime()}`,
                            "info"
                        );

                        notifiedAlarms[key] = log.regDt;
                    }
                });

                // hold 되지 않은 동일건을 그룹화 한다. 여기서는 Noti된 것을 빼면 안됨..
                // const alarmMap = grouping(alarmLogs);
                // 화면에 표시할 알람로그 목록
                // 초기화 후에, Noti와 상관없이, 해결되지 않은 알람이면 화면상단 목록에 표시해야 한다.
                // setAlarmList(this.alarms, alarmMap);
                // 이미 Noti 한것인지 여부를 storage에 저장하여 사용함..

                // forObj(alarmMap, (group, key) => {
                // 	console.log(group);
                // 	let isIncludes = group.find((v) => v.regDt === notifiedAlarms[key]);
                // 	console.log(isIncludes);

                // 	if (this.isEmpty(isIncludes)) {
                // 		let log = group[0];

                // 		this.alertNoti("알람", `${log.alarmGroup} <br /> ${log.description} <br /><br /> ${log.regDt.passedTime()}`, "info");

                // 		notifiedAlarms[key] = log.regDt;
                // 	}
                // });

                // 지속적으로 노티되지 않도록 함..
                localStorage.notifiedAlarms = JSON.stringify(notifiedAlarms);
                localStorage.alarmLogs = JSON.stringify(this.formerAlarms);
            } catch (err) {
                console.error("Header onChangeAlarms error:", err);
            }
        },

        // 네비게이션
        openAlarmList() {
            this.$router.push("/system-mgmt/alarm-mgmt");
            this.dropdownOpen = false;
        },

        // 테스트용 (예비)
        test() {},
    },
};
</script>

<style scoped>
.bell-icon {
    font-size: 20px;
}
.alarm-dropdown-container {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
}

.alarm-toggle {
    position: relative;
    width: 40px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    margin-left: 5px;
}

.alarm-toggle .label {
    position: absolute;
    top: -10px;
    right: 0;
    margin-left: 4px;
    font-size: 10px;
    padding: 1px 3px;
    border-radius: 15px;
}

.alarm-dropdown-menu {
    position: absolute;
    top: 110%;
    right: -320%;
    min-width: 320px;
    max-width: 360px;
    /* max-height: 90vh;
    overflow-y: auto; */
    background: #fff;
    /* border: 1px solid #ddd; */
    box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
    z-index: 1000;
    padding: 0;
    border-radius: 6px;
}

.dropdown-header {
    padding: 8px 12px;
    font-weight: bold;
    border-bottom: 1px solid #eee;
    height: 42px;
    font-size: 12px;
    color: #333333;
    background-color: #e9edf3;
    border-radius: 6px 6px 0 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.dropdown-item {
    padding: 8px 12px;
    cursor: pointer;
}

.dropdown-item:hover {
    background: #f5f5f5;
}

.toasts-wrapper {
    /* toast 컨테이너 스타일 조정 필요 시 */
}
.fade-popup-enter-active,
.fade-popup-leave-active {
    transition: opacity 0.2s;
}
.fade-popup-enter,
.fade-popup-leave-to {
    opacity: 0;
}
.drop-down-else {
    background-color: #e9edf3;
    padding: 8px 12px;
    height: 42px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    border-radius: 0 0 6px 6px;
    transition: background-color 0.3s ease;
    font-weight: bold;
}
.drop-down-else:hover {
    background-color: #d5dbe4;
}
.alarm-event-hide {
    background: none;
    border: none;
    font-size: 13px;
    font-weight: bold;
    color: #888;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    width: 25px;
    height: 25px;
}
.alarm-event-hide:focus {
    outline: none;
}
.alarm-event-hide:hover {
    background-color: #e0e0e0;
}
.alarm-scroll-container {
    max-height: 90vh;
    overflow-y: auto;
}
</style>
